import { put, delay, takeEvery } from "redux-saga/effects";
import * as types from "./types";

import { appInstance, davInstance } from "axios-config";
import * as actions from "store/actions";
import { NOTIFICATIONS } from "consts";
import { NOTIFICATION_STATUS } from "App/componentsConfig";
import { encryptData, scrollToView, waitForConnection } from "utils";

export function* fetchAccountDetailsStart() {
  try {
    const response = yield appInstance.get("/account/details");

    if (response.status === 200)
      yield put(actions.fetchAccountDetailsSuccess(response.data));
  } catch (error) {
    console.log(error);
  }
}

export function* cancelAccountStart(action) {
  try {
    const response = yield davInstance.post(
      "/user/cancellation",
      action.details
    );

    if (response.data.code === 200) {
      yield put(actions.cancelAccountPNSStart());
      yield put(actions.cancelAccountSuccess());
      yield put(actions.logoutUser());
      yield put(actions.cancelAccountResetState());
    } else if (response.data.code === 400) {
      yield put(actions.cancelAccountFailure(response.data.message.message));
      yield delay(2000);
      yield put(actions.cancelAccountResetState());
    }
  } catch (error) {
    console.log(error);
  }
}

export function* updateProfileDetailsStart(action) {
  try {
    let oldEmail = action.details.emailid;
    if (action.details.oldEmail) {
      oldEmail = { ...action.details.oldEmail };
      delete action.details.oldEmail;
    }
    const response = yield davInstance.put("/user/update", action.details);

    const details = {
      error: false,
      msg: ""
    };

    if (response.data.code === 200) {
      details.msg = NOTIFICATIONS.account.profile.success;

      yield put(actions.emailUpdated(true));
      yield put(actions.updateProfileDetails(action.details));
      yield scrollToView("notifyPass");
      yield put(actions.showAccountNotificationWithTimeout(details));
      yield put(actions.reEnterPasswordResetState());
      if (oldEmail !== action.details.emailid) {
        yield put(actions.initiateAccountActivityChange());
        yield put(actions.accountSettingsChangedPNSStart());
      }
    } else if (response.data.code === 400 || response.data.code === 500) {
      yield put(actions.reEnterPasswordFailure(response.data.message.message));
      yield delay(2000);
      yield put(actions.reEnterPasswordResetState());
    }
  } catch (error) {
    console.log(error);
  }
}

export function* updatePasswordStart(action) {
  try {
    const response = yield davInstance.put("/user/updatePassword", null, {
      params: {
        newPassword: action.details.newPassword,
        oldPassword: action.details.oldPassword
      }
    });

    const details = {
      error: false,
      msg: ""
    };
    if (response.data.code === 200) {
      details.msg = NOTIFICATIONS.account.passwordUpdate.success;
      yield put(actions.updatePasswordSuccess());
      yield scrollToView("notifyPass");
      yield put(actions.showAccountNotificationWithTimeout(details));
      yield put(actions.updatePasswordResetState());
    } else if (response.data.code > 300) {
      yield put(actions.updatePasswordFailure(response.data.message.message));
      yield delay(2000);
      yield put(actions.updatePasswordResetState());
    }
  } catch (error) {
    console.log(error);
  }
}

export function* initiateAccountActivityChange(params) {
  yield takeEvery(types.INITIATE_ACCOUNT_ACTIVITY_CHANGE, action => {
    const req = {
      action: "accountActivityChanged"
    };

    waitForConnection(params.wsConnection, req, 1000);
  });
}

export function* upgradePlanStart(action) {
  try {
    const response = yield davInstance.post("/upgrade", action.details);

    const details = {
      error: false,
      msg: ""
    };
    if (response.data.code === 200) {
      details.msg = NOTIFICATIONS.account.upgradePlan.success;
      yield scrollToView("notifyPass");
      yield put(actions.showAccountNotificationWithTimeout(details));
      yield put(actions.changeToPaidPlan(action.plan));
      yield put(actions.upgradePlanSuccess());
      yield put(actions.fetchCCDetailsStart());
      yield put(actions.fetchRenewalPriceStart());
      yield put(actions.initiateUpgradePlan(action.plan));
    } else if (response.data.code === 400 || response.data.code === 500) {
      details.msg = response.data.message.message;
      details.error = true;
      yield scrollToView("notifyPass");
      yield put(actions.showAccountNotificationWithTimeout(details));
      yield put(actions.upgradePlanSuccess());
    }
  } catch (error) {
    console.log(error);
  }
}

export function* initiateUpgradePlan(params) {
  yield takeEvery(types.INITIATE_UPGRADE_PLAN, action => {
    const req = {
      action: "upgradePlan",
      data: action.plan
    };

    waitForConnection(params.wsConnection, req, 1000);
  });
}

export function* fetchUpgradeProChargeStart(action) {
  try {
    const response = yield davInstance.post(
      "/getUpgProrateCharge",
      action.details
    );

    const details = {
      error: false,
      msg: ""
    };
    if (response.data.code === 200) {
      action.openPop.openPop("upgradePlan", {
        body: {
          AMOUNT: response.data.message.message.split(":")[1].trim(),
          planId: action.details.payment_info.plan_id
        },
        execute: () => {
          action.openPop.upgrade();
          // action.openPop.close();
        }
      });
      yield put(actions.fetchUpgradeProChargeSuccess());
    } else if (response.data.code === 400 || response.data.code === 500) {
      details.msg = NOTIFICATIONS.account.upgradePlan.failure;
      details.error = true;
      console.log("error");
      yield scrollToView("notifyPass");
      yield put(actions.showAccountNotificationWithTimeout(details));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* updateCreditCardStart(action) {
  try {
    const response = yield davInstance.post("/updateCC", action.details);

    const details = {
      error: false,
      msg: ""
    };
    if (response.data.code === 200) {
      details.msg = NOTIFICATIONS.account.updateCreditCard.success;
      yield scrollToView("notifyPass");
      yield put(actions.showAccountNotificationWithTimeout(details));
      yield put(actions.showNotificationWithTimeout("dashboard", details));
      yield put(
        actions.showNotificationWithTimeout("backupPlan", {
          status: NOTIFICATION_STATUS.success.name,
          msg: details.msg
        })
      );
      yield put(
        actions.showNotificationWithTimeout("restore", {
          status: NOTIFICATION_STATUS.success.name,
          msg: details.msg
        })
      );
      yield put(
        actions.showNotificationWithTimeout("webActivity", {
          status: NOTIFICATION_STATUS.success.name,
          msg: details.msg
        })
      );
      yield put(
        actions.showNotificationWithTimeout("users", {
          status: NOTIFICATION_STATUS.success.name,
          msg: details.msg
        })
      );

      yield put(actions.fetchCCDetailsStart());
      yield put(actions.updateCreditCardSuccess());
    } else if (response.data.code === 400 || response.data.code === 500) {
      // details.msg = NOTIFICATIONS.account.updateCreditCard.failure;
      details.msg = response.data.message.message;
      yield put(actions.updateCreditCardSuccess());
      details.error = true;
      yield scrollToView("notifyPass");
      yield put(actions.showAccountNotificationWithTimeout(details));
      yield put(actions.showNotificationWithTimeout("dashboard", details));
      yield put(
        actions.showNotificationWithTimeout("backupPlan", {
          status: NOTIFICATION_STATUS.failure.name,
          msg: details.msg
        })
      );
      yield put(
        actions.showNotificationWithTimeout("restore", {
          status: NOTIFICATION_STATUS.failure.name,
          msg: details.msg
        })
      );
      yield put(
        actions.showNotificationWithTimeout("webActivity", {
          status: NOTIFICATION_STATUS.failure.name,
          msg: details.msg
        })
      );
      yield put(
        actions.showNotificationWithTimeout("users", {
          status: NOTIFICATION_STATUS.failure.name,
          msg: details.msg
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export function* fetchCCDetailsStart() {
  try {
    const response = yield davInstance.get("/getCCDetails");
    yield put(actions.fetchCCDetailsSuccess(response.data));
    localStorage.setItem(
      "ccDetails",
      encryptData(JSON.stringify(response.data))
    );
  } catch (error) {
    console.log(error);
  }
}

export function* fetchBillingInfoStart() {
  try {
    const response = yield davInstance.get("/getBillinginfo");

    yield put(actions.fetchBillingInfoSuccess(response.data));
  } catch (error) {
    console.log(error);
  }
}

export function* fetchRenewalPriceStart() {
  try {
    const response = yield davInstance.get("/getRenewalPrice");
    if (response.data.code === 200) {
      yield put(
        actions.fetchRenewalPriceSuccess(
          JSON.parse(response.data.message.message)
        )
      );
    } else {
      console.log(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* fetchUserPlansStart() {
  try {
    const response = yield davInstance.get("/plan/getPlansOfUser");
    if (response.data.code === 200) {
      yield put(actions.fetchUserPlansSuccess(response.data.message));
    } else {
      console.log(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* accountSettingsChangedPNSStart(params) {
  yield takeEvery(types.ACCOUNT_SETTINGS_CHANGED_PNS_START, action => {
    const req = {
      action: "accountSettingsChanged"
    };

    waitForConnection(params.wsConnection, req, 1000);
  });
}

export function* cancelAccountPNSStart(params) {
  yield takeEvery(types.CANCEL_ACCOUNT_PNS_START, action => {
    const req = {
      action: "accountCancelled"
    };

    waitForConnection(params.wsConnection, req, 1000);
  });
}

export function* applyPendingChargesStart(action) {
  try {
    const details = {
      error: false,
      msg: ""
    };
    const response = yield davInstance.post(
      "/applyPendingCharges",
      action.details
    );
    if (response.data.code === 200) {
      yield put(actions.fetchCCDetailsStart());
      yield put(actions.updateCreditCardSuccess());
      details.msg = NOTIFICATIONS.account.applyPendingCharges.success;
      details.error = false;
      yield scrollToView("notifyPass");
      yield put(actions.showAccountNotificationWithTimeout(details));
      yield put(
        actions.showNotificationWithTimeout("webActivity", {
          status: NOTIFICATION_STATUS.failure.name,
          msg: details.msg
        })
      );
    } else if (response.data.code === 400 || response.data.code === 500) {
      yield put(actions.applyPendingChargesFailed());
      details.msg = NOTIFICATIONS.account.applyPendingCharges.failure;
      details.error = true;
      yield scrollToView("notifyPass");
      yield put(actions.showAccountNotificationWithTimeout(details));
      yield put(
        actions.showNotificationWithTimeout("webActivity", {
          status: NOTIFICATION_STATUS.failure.name,
          msg: details.msg
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}
